import { EdelError } from "@adapters/infrastructures/interfaces/errors";
export class BaseUseCase {
    async execute(listener, requestData) {
        await this.fetchResult(requestData)
            .then((result) => {
            listener.onSuccess(result);
        })
            .catch((err) => {
            listener.onError(this.handleError(err));
        });
    }
    handleError(err) {
        let edelError = new EdelError(0, null);
        if (err instanceof EdelError) {
            edelError = err;
        }
        return edelError;
    }
}
